// @owners { team: patients-team }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding } from '@alto/design-system';
import React from 'react';
import { PROGRAM_DISPENSING_FEE_DETAILS_COPY } from '~shared/features/pricing/constants';

export const DispensingFeeDetailsActionSheet = () => {
  return (
    <ActionSheetV2
      title="Fee details"
      analyticsName="dispensing fee details"
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body>{PROGRAM_DISPENSING_FEE_DETAILS_COPY}</Body>
      </LgPadding>
    </ActionSheetV2>
  );
};
